import { useReducedMotion } from "framer-motion";
import type { Variants } from "framer-motion";
import { fadeUp } from "../components/motion/tokens";

/**
 * Scroll-into-view reveal props for an `m.*` element.
 * When the user prefers reduced motion the element renders in its final
 * state with no animation (`initial={false}`).
 */
export function useReveal(variants: Variants = fadeUp) {
  const reduce = useReducedMotion();
  if (reduce) {
    return { initial: false as const };
  }
  return {
    initial: "hidden" as const,
    whileInView: "visible" as const,
    viewport: { once: true, margin: "0px 0px -12% 0px" },
    variants,
  };
}
